const Pause = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke="#000" strokeWidth="2" d="M4 3h4v18H4zM16 3h4v18h-4z" />
    </svg>
)

export default Pause;